<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-input placeholder="请输入名称" v-model="params.title"  style="width: 200px;" size="medium"></el-input> -->
      <el-button
        type="primary"
        size="small"
        @click="handleQuery()"
        class="add-input"
        >刷新</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="vipOperation('add', tableData)"
        class="add-input"
        >+新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      height="100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="名称" align="center">
      </el-table-column>
      <el-table-column label="封面图" align="center" width="120">
        <template slot-scope="scope">
          <img-load
            height="30px"
            v-if="showImgLoad && scope.row.cover"
            :src="imgUrl + '/' + scope.row.cover"
          ></img-load>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status === 1 ? "开启" : "关闭" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="vipOperation('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeAdmin(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <div>
      <el-pagination
        :page-sizes="[5, 10, 15, 20]"
        :current-page="params.pageNumber"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </div>
    <!--新增、编辑弹框-->
    <position-action
      ref="positionAction"
      @handlerProductList="handlerProductList"
    ></position-action>
  </div>
</template>
<script>
import API from "@/api";
import positionAction from "./components/positionAction";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      showImgLoad: false,
      tableData: [],
      imgUrl: baseConfig.imgUrl,
      total: 0,
      // 列表请求参数
      params: {
        title: '',
        pageNumber: 1,
        pageSize: 20,
      },
    };
  },
  components: {
    positionAction,
  },
  created() {
    this.getPositionList(this.params);
  },
  methods: {
    // 请求商品列表
    getPositionList() {
      this.loading = true;
      API.getJGConfigList(this.params)
        .then((res) => {
          this.showImgLoad = true;
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.showImgLoad = false;
          this.loading = false;
        });
    },
    handleQuery(){
      this.params.pageSize = 1
      this.getPositionList()
    },
    // 删除管理员
    removeAdmin(row) {
      this.$confirm("您确定要删除当前项吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.removeJGConfig({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getPositionList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.positionAction.open(type, data);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getPositionList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getPositionList();
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerProductList() {
      this.getPositionList();
    },
  },
};
</script>

<style lang="scss">
.action-bar{
  display: flex;
  gap: 5px;
  height: 24px;
  align-items: center;
}
.vipProductList-box {
  display: flex;
  height: 100%;
  flex-direction: column;
}
</style>
